import { EditorContent } from "@tiptap/react";
import type { DocumentEditorProps } from "../../types";
import { useTipTapDocumentEditor } from "./useTipTapDocumentEditor";
import { EditorToolbar } from "./EditorToolbar";

export function TipTapDocumentEditor({
  content,
  onChange,
  readOnly,
  placeholder,
  onReady,
  className,
}: DocumentEditorProps) {
  const { editor } = useTipTapDocumentEditor({
    content,
    onChange,
    readOnly,
    placeholder,
    onReady,
  });

  return (
    <div
      className={[
        "rounded-xl border border-default-200 bg-white dark:bg-default-100/5 shadow-sm overflow-auto",
        className ?? "",
      ]
        .join(" ")
        .trim()}
      dir="rtl"
    >
      {!readOnly && <EditorToolbar editor={editor} />}
      <EditorContent editor={editor} />
    </div>
  );
}
